export const QAList = [
  "什么样的情况不适合做手术？",
  "术后可以恢复正常工作吗？",
  "如果出现排斥反应怎么办？",
  "术后需要服用什么药物？这些药物有哪些副作用？",
  "术后可以恢复正常工作吗？",
];
